import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: number | string;
  trend?: {
    value: number;
    direction: 'up' | 'down' | 'neutral';
  };
  accentColor?: string;
  className?: string;
}

export function StatCard({
  icon,
  label,
  value,
  trend,
  accentColor = 'text-accent-blue',
  className,
}: StatCardProps) {
  const TrendIcon = trend?.direction === 'up' 
    ? TrendingUp 
    : trend?.direction === 'down' 
      ? TrendingDown 
      : Minus;

  const trendColor = trend?.direction === 'up'
    ? 'text-accent-red'
    : trend?.direction === 'down'
      ? 'text-accent-green'
      : 'text-text-secondary';

  return (
    <div
      className={cn(
        'glass-card p-4 flex flex-col gap-3',
        className
      )}
    >
      <div className="flex items-center justify-between">
        <span className={cn('p-2 rounded-md bg-bg-tertiary', accentColor)}>{icon}</span>
        {trend && (
          <div className={cn('flex items-center gap-1 text-xs', trendColor)}>
            <TrendIcon className="w-3 h-3" />
            <span>{Math.abs(trend.value)}%</span>
          </div>
        )}
      </div>
      <div>
        <div className="text-2xl font-sans font-bold text-text-primary">{value}</div>
        <div className="text-xs text-text-secondary uppercase tracking-wide mt-1">{label}</div>
      </div>
    </div>
  );
}

